export default {"src":"/_next/static/media/car100_64.e1b0f165.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};